import { NgComponentOutlet } from '@angular/common';
import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { isObject } from '@kp/utils';

import { MODAL_DATA } from './modal.token';

import type { OnInit, Type } from '@angular/core';
import type { Subject } from 'rxjs';

@Component({
  selector: 'kp-tiia-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css',
  encapsulation: ViewEncapsulation.None,
  host: {
    class:
      'flex w-[90vw] flex-col rounded-sm border border-gray-300 bg-white p-2 md:p-4 [@media(min-width:800px)]:w-[800px]',
  },
  imports: [NgComponentOutlet],
})
export class ModalComponent implements OnInit {
  close$: Subject<unknown> | undefined;
  component?: Type<unknown>;
  data?: unknown;
  html?: string;
  info?: string;
  readonly injector?: Injector;
  modalInjector: Injector | undefined;
  overflow = false;
  title?: string;

  ngOnInit(): void {
    this.modalInjector = Injector.create({
      providers: [
        {
          provide: MODAL_DATA,
          useValue: {
            ...(isObject(this.data) ? this.data : {}),
            close$: this.close$,
          },
        },
      ],
      ...(this.injector ? { parent: this.injector } : {}),
    });
  }

  close(): void {
    this.close$?.next(undefined);
  }
}
